'use strict';

import { GLOBAL } from './Global';
import { SENDER_V2 as SENDER_V2_PERMISSION_GROUPS } from '../PermissionsGroups';

const SENDER_V2_permissions_list = [];

for (const [key, value] of Object.entries(SENDER_V2_PERMISSION_GROUPS)) {
  SENDER_V2_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SENDER_V2 = {
  can: [
    ...GLOBAL.can,
    ...SENDER_V2_permissions_list,
  ],
};

export {
  SENDER_V2,
};
